import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

export interface ProfileMobileSidebarProps {
  /** Optional className override; merged via `cn()` over the base styling. */
  className?: string;
  children: ReactNode;
}

/**
 * Mobile-only sidebar wrapper rendered inline below the main scroll area on
 * narrow viewports. Applies the canonical `"md:hidden border-t border-border"`
 * styling (hidden on desktop where the sidebar lives in its own column via
 * {@link ProfileSidebarColumn}).
 */
export function ProfileMobileSidebar({
  className,
  children,
}: ProfileMobileSidebarProps) {
  return (
    <div className={cn("md:hidden border-t border-border", className)}>
      {children}
    </div>
  );
}
